module.exports = __webpack_public_path__ + "static/media/File.bbdacd6b.svg";